import { Popconfirm } from 'antd'
export const getColumns = (filters, handleCronDelete) => {
    return [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            filteredValue: filters["name"],
            filterSearch: true,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            filteredValue: filters["status"],
            filterSearch: true,
        },
        {
            title: 'Error',
            dataIndex: 'err',
            key: 'err',
        },
        {
            title: 'Duration (Mints)',
            dataIndex: 'duration',
            key: 'duration',
            sorter: true,
            render: ((d) => {
                return d ? (d / 60).toFixed(2) : d
            }),

        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: true,
            render: ((d) => {
                return new Date(d).toLocaleString()
            })
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            render: (_, record) =>
                <Popconfirm title="Sure to delete?" onConfirm={() => handleCronDelete(record.key)}>
                    <a>Delete</a>
                </Popconfirm>
        }
    ]
}

export const getGraphQlItems = () => {
    return ['name', 'status', 'err', 'duration', 'createdAt'];
}